import { STOP_TYPE } from 'transfix-ui/components/MapMarker'
import { IStop } from 'types/FMSGraphqlTypes'

export const getMapMarkerType = (stopType: IStop): STOP_TYPE => {
  return stopType === IStop.pickup ? STOP_TYPE.pickup : STOP_TYPE.dropoff
}
